module.exports = __webpack_public_path__ + "img/banner-rain.b43004b6.png";